import { POLICY_EXCEPTIONS_WRITE } from "@/const/policy-exception.constants"
import { isDataAvailable } from "@/helpers/context.helper"
import { useNumberConvertor } from "@/hooks/useNumberConvertor"
import { useOrderBy } from "@/hooks/useOrderBy"
import { useTooltip } from "@/hooks/useTooltip"
import { useTranslation } from "@/hooks/useTranslation"
import { useUser } from "@/hooks/useUser"
import { useScanHistory } from "@/pages/GovernancePage/applications/scan-history/useScanHistory"
import { TabTemplate } from "@/templates/TabTemplate"
import { FilterScanHistoryTab } from "../FilterScanHistoryTab"
import { HeaderScanHistoryTab } from "../HeaderScanHistoryTab"
import { getColumnsTable } from "./getColumnsTable"

import styles from "./ScanHistoryTab.module.scss"

const ScanHistoryTab = () => {
  const context = useScanHistory()
  const { response, isLoading } = context
  const { data, metadata } = response || {}
  const { t } = useTranslation()
  const convertors = useNumberConvertor()
  const hasData = isDataAvailable(context)
  const { hasPermission } = useUser()
  const canReview = !!hasPermission(POLICY_EXCEPTIONS_WRITE)
  const { onSorterChange, ...sorter } = useOrderBy()

  useTooltip(data)

  return (
    <TabTemplate
      resizable
      classes={{ row: styles.row }}
      columns={getColumnsTable({
        t,
        convertors,
        sorter,
        popover: false,
        canReview
      })}
      loading={isLoading}
      dataSource={data}
      metadata={metadata}
      headerComponent={<HeaderScanHistoryTab />}
      SearchComponent={<FilterScanHistoryTab hasData={hasData} />}
      onChange={(_pagination, _filters, sorter) => {
        onSorterChange(sorter)
      }}
    />
  )
}

export default ScanHistoryTab
